export default __webpack_public_path__ + "static/wafd-mobile-app-qr-e814edfc5d4388c0aacdafc39965f6ab.svg";